module.exports = __webpack_public_path__ + "img/clear_grey.dcb324da.svg";